export const weaponNames: Record<string, string> = {
	wname_BarrierGun: "Barrier",
	wname_CannonBurst: "Cannon burst",
	wname_Cannon: "Cannon",
	wname_Solidifier: "Solidifier",
	wname_AirBlast: "Air Blast",
	wname_CryoGun: "Cryo Gun",
	wname_RockGun: "Rock gun",
	wname_DebugRemoteControl: "Remote Control",
	wname_DevGunAutoKill: "Auto Kill Bot",
	wname_DrillLauncher: "Drill",
	wname_PlasmaGun: "Plasma",
	wname_Flamethrower: "Flamethrower",
	wname_GasBombWeapon: "Gas bomb",
	wname_LandmineWeapon: "Mine",
	wname_LaserGun: "Laser",
	wname_MissileBurst: "Missile burst",
	wname_MissileGun: "Missile",
	wname_OpGun: "Overpowered Gun Mk1",
	wname_OpGun2: "Level clearer",
	wname_OpGunNuke: "Nuke",
	wname_Punch: "Punch",
	wname_TripleSolidifier: "Triple Solidifier",
	wname_Jetpack: "Jetpack",
	wname_Sword: "Sword",
	wname_Cleaver: "Cleaver",
	wname_BlackHoleGun: "Black Hole Gun",
};
